import * as activitiesApi from "@/api/activitiesApi.js"

import * as sentryReporter from "@/services/sentryReporter.js"

import { useAppStateStore } from "@/store/appState.js"

export const undoMarkAllActivitiesAsRead = async () => {
  try {
    const appStateStore = useAppStateStore()
    await activitiesApi.undoMarkAllAsRead()
    appStateStore.setInboxDisplayed(false)
    appStateStore.setInboxDisplayed(true)
  } catch (err) {
    sentryReporter.reportError(err)
  }
}
